import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import CreditPlanProvider  from './creditPlan/CreditPlanProvider';

export function GlobalProviders({ children }: PropsWithChildren) {
  return (
    <>
      <CreditPlanProvider>{children}</CreditPlanProvider>
    </>
  );
}

export default function GlobalProvidersLayout() {
  return (
    <>
      <GlobalProviders>
        <Outlet />
      </GlobalProviders>
    </>
  );
}
